import { Component, OnInit } from '@angular/core';
import { Router, NavigationEnd } from "@angular/router";
import { Title } from '@angular/platform-browser';

import { ChartOptions, ChartType, ChartDataSets } from 'chart.js';
import { Label } from 'ng2-charts';

@Component({
    selector: 'app-redemptions-reporting-applications',
    templateUrl: './redemptions-reporting-applications.component.html',
    providers: [Title]
})
export class RedemptionReportingApplicationsComponent implements OnInit {

    mychart1: boolean = true;
    //mychart2: boolean = true;
    //mychart3: boolean = true;

    constructor(private title: Title, private router: Router) {
        this.title.setTitle('Dashboard - Applications | XYZ Corp. Verification Workspace');
    }

    ngOnInit() {
        this.router.events.subscribe((evt) => {
            if (!(evt instanceof NavigationEnd)) {
                return;
            }
            window.scrollTo(0, 0)
        });

        this.refreshChart1();
        //this.refreshChart2();
        //this.refreshChart3();

    }

    ///////////////////////////////////////// SHARED OPTIONS ///////////////////////////////////////////////////

    public legendTrue: boolean = true;
    public legendFalse: boolean = false;
    public chartTypeBar: string = 'bar';
    public chartTypeDoughnut: string = 'doughnut';
    public chartTypePolarArea: string = 'polarArea';
    public chartTypeLine: string = 'line';


    ///////////////////////////////////// CHART SPECIFIC OPTIONS ///////////////////////////////////////////////

    public weeklyApplicationVolumesOptions: any = {
        scaleShowVerticalLines: false,
        legend: {
            position: 'bottom',
            labels: {
                usePointStyle: true
            }
        },
        responsive: true,
        maintainAspectRatio: false,
        scales: {
            yAxes: [{
                stacked: false,
                scaleLabel: {
                    display: true,
                    labelString: '# Redemptions',
                    fontSize: '14',
                    fontStyle: 'bold'
                },
                ticks: {
                    beginAtZero: true
                }
            }],
            xAxes: [{
                stacked: false,
                scaleLabel: {
                    display: true,
                    labelString: 'Last 14 Days',
                    fontSize: '14',
                    fontStyle: 'bold'
                },
                ticks: {
                    beginAtZero: true
                },
                gridLines: {
                    display: false
                }
            }]
        }
    };

    public buySellOptions: any = {
        scaleShowVerticalLines: false,
        legend: {
            position: 'bottom',
            labels: {
                usePointStyle: true
            }
        },
        responsive: true,
        maintainAspectRatio: false,
        scales: {
            yAxes: [{
                stacked: false,
                scaleLabel: {
                    display: true,
                    labelString: 'Value',
                    fontSize: '14',
                    fontStyle: 'bold'
                },
                ticks: {
                    beginAtZero: true,
                    suggestedMin: -600000,
                    suggestedMax: 600000,
                    callback: function (label, index, labels) {
                        return label / 1000000 + 'm';
                    }
                }
            }],
            xAxes: [{
                stacked: false,
                scaleLabel: {
                    display: true,
                    labelString: 'Month',
                    fontSize: '14',
                    fontStyle: 'bold'
                },
                ticks: {
                    beginAtZero: true
                },
                gridLines: {
                    display: false
                }
            }]
        }
    };

    public doughnutChartOptions: any = {
        responsive: true,
        maintainAspectRatio: false,
        cutoutPercentage: 80,
        legend: {
            position: 'bottom',
            display: true,
            labels: {
                usePointStyle: true
            }
        }
    };

    public doughnutChartPercentageOptions: any = {
        responsive: true,
        maintainAspectRatio: false,
        tooltips: {
            callbacks: {
                label: function (tooltipItem, data) {
                    var dataset = data.datasets[tooltipItem.datasetIndex];
                    var total = dataset.data.reduce(function (previousValue, currentValue, currentIndex, array) {
                        return previousValue + currentValue;
                    });
                    var currentValue = dataset.data[tooltipItem.index];
                    var percentage = Math.floor(((currentValue / total) * 100) + 0.5);
                    return percentage + "%";
                }
            }
        },
        cutoutPercentage: 80,
        legend: {
            position: 'bottom',
            display: true,
            labels: {
                usePointStyle: true
            }
        }
    };

    public barCharOptions: any = {
        responsive: true,
        maintainAspectRatio: false,
        tooltips: {
            enabled: true,
            mode: 'single',
            callbacks: {
                label: function (tooltipItem, data) {
                    var value = data.datasets[0].data[tooltipItem.index];
                    if (parseInt(value) >= 1000) {
                        return 'Value: ' + value.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
                    } else {
                        return 'Value: ' + value;
                    }
                }
            }
        },
        scales: {
            yAxes: [{
                stacked: true,
                scaleLabel: {
                    display: true,
                    labelString: 'Value',
                    fontSize: '14',
                    fontStyle: 'bold'
                },
                ticks: {
                    beginAtZero: true,
                    callback: function (label, index, labels) {
                        return label / 1000000 + 'm';
                    }
                }
            }],
            xAxes: [{
                stacked: true,
                maxBarThickness: 60,
                ticks: {
                    beginAtZero: true
                },
                gridLines: {
                    display: false
                }
            }]
        },
        legend: {
            position: 'bottom',
            display: false,
            labels: {
                usePointStyle: true
            }
        },
        plugins: {
            labels: {
                fontSize: 0
            }
        }

    }

    ///////////////////////////////////////// LABELS & DATA ////////////////////////////////////////////////////

    public weeklyApplicationVolumesLabels: string[] = ['1', '2', '3', '4', '5', '6', '7', '8', '9', '10', '11', '12', '13', '14'];
    public weeklyApplicationVolumesData: any[] = [
        { data: [123, 216, 170, 144, 167, 245, 190, 210, 234, 198, 98, 212, 111, 253, 123], label: 'Applications' }
    ];

    public doughnutChart1Labels: string[] = ['Company Approved', 'Company Rejected', 'CPU Processed', 'CPU Rejected', 'Finance Approved', 'New Holder'];
    public doughnutChart1Data: number[] = [354, 49, 1132, 47, 301, 407];

    public barChart1Labels: string[] = ['Leveraged', 'Non-Leveraged'];
    public barChart1Data: number[] = [206780, 342000];

    public barChart2Labels: string[] = ['Death', 'Disability', 'Incompetence', 'RMD', 'General'];
    public barChart2Data: number[] = [318210, 242000, 345674, 381976, 723141];

    public buySellLabels: string[] = ['Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul'];
    public buySellData: any[] = [
        { data: [450000, 345000, -105000, -98000, 167000, 245000], label: 'Applications' }
    ];

    //////////////////////////////////////////// COLOURS ///////////////////////////////////////////////////////
    public solidBackgroundColors = [
        {
            backgroundColor: ['rgba(67,91,115,1)', 'rgba(193,189,170,1)', 'rgba(224,216,174,1)', 'rgba(115,91,93,1)', 'rgba(112,114,112,1)', 'rgba(163,170,163,1)', 'rgba(128,109,141,1)', 'rgba(112,92,126,1)', 'rgba(146,114,166,1)']
        }
    ];

    public transparentBackgroundColors = [
        {
            backgroundColor: ['rgba(104,132,155,0.8)', 'rgba(188,201,210,0.8)', 'rgba(193,189,170,0.8)', 'rgba(224,216,174,0.8)', 'rgba(163,170,163,0.8)']
        }
    ];

    public lineChartColors = [
        {
            backgroundColor: 'rgba(67,91,115,0.05)',
            borderColor: 'rgba(67,91,115,1)',
            pointBackgroundColor: '#fff',
            pointBorderColor: 'rgba(67,91,115,1)',
            pointHoverBackgroundColor: '#fff',
            pointHoverBorderColor: 'rgba(67,91,115,1)',
            borderWidth: 3,
            pointRadius: 4,
            pointBorderWidth: 3
        },
        {
            backgroundColor: 'rgba(193,189,170,0.05)',
            borderColor: 'rgba(193,189,170,1)',
            pointBackgroundColor: '#fff',
            pointBorderColor: 'rgba(193,189,170,1)',
            pointHoverBackgroundColor: '#fff',
            pointHoverBorderColor: 'rgba(193,189,170,1)',
            borderWidth: 3,
            pointRadius: 4,
            pointBorderWidth: 3
        },
        {
            backgroundColor: 'rgba(224,216,174,0.05)',
            borderColor: 'rgba(224,216,174,1)',
            pointBackgroundColor: '#fff',
            pointBorderColor: 'rgba(224,216,174,1)',
            pointHoverBackgroundColor: '#fff',
            pointHoverBorderColor: 'rgba(224,216,174,1)',
            borderWidth: 3,
            pointRadius: 4,
            pointBorderWidth: 3
        },
        {
            backgroundColor: 'rgba(115,91,93,0.05)',
            borderColor: 'rgba(115,91,93,1)',
            pointBackgroundColor: '#fff',
            pointBorderColor: 'rgba(115,91,93,1)',
            pointHoverBackgroundColor: '#fff',
            pointHoverBorderColor: 'rgba(115,91,93,1)',
            borderWidth: 3,
            pointRadius: 4,
            pointBorderWidth: 3
        },
        {
            backgroundColor: 'rgba(112,114,112,0.05)',
            borderColor: 'rgba(112,114,112,1)',
            pointBackgroundColor: '#fff',
            pointBorderColor: 'rgba(112,114,112,1)',
            pointHoverBackgroundColor: '#fff',
            pointHoverBorderColor: 'rgba(112,114,112,1)',
            borderWidth: 3,
            pointRadius: 4,
            pointBorderWidth: 3
        },
        {
            backgroundColor: 'rgba(163,170,163,0.05)',
            borderColor: 'rgba(163,170,163,1)',
            pointBackgroundColor: '#fff',
            pointBorderColor: 'rgba(163,170,163,1)',
            pointHoverBackgroundColor: '#fff',
            pointHoverBorderColor: 'rgba(163,170,163,1)',
            borderWidth: 3,
            pointRadius: 4,
            pointBorderWidth: 3
        }
    ];

    // events
    public chartClicked(e: any): void {
        //console.log(e);
    }
    public chartHovered(e: any): void {
        //console.log(e);
    }

    refreshChart1() {
        this.mychart1 = false;
        setTimeout(() => {
            this.mychart1 = true;
        }, 1);
    }

    //refreshChart2() {
    //    this.mychart2 = false;
    //    setTimeout(() => {
    //        this.mychart2 = true;
    //    }, 1);
    //}

    //refreshChart3() {
    //    this.mychart3 = false;
    //    setTimeout(() => {
    //        this.mychart3 = true;
    //    }, 1);
    //}

    handleChange1(e) {
        this.refreshChart1();
    }

    //handleChange2(e) {
    //    this.refreshChart2();
    //}

    //handleChange3(e) {
    //    this.refreshChart3();
    //}

}
